import {
    setUserId,
    getUserId,
    removeUserId,
    setUserName,
    getUserName,
    removeUserName,
    setUserIcon,
    getUserIcon,
    removeUserIcon,
    clearStorage,
    //   setinfo,
    //   removeinfo,
    removeToken,
    //   getwriter,
    // setwriter,
    // removewriter
} from "utils/storage";
// let info = JSON.parse(getinfo());
import { login, logout, getInfo } from "apiurl/login";
const user = {
    state: {
        id: getUserId(), //用户id
        name: getUserName(),//用户昵称
        icon: getUserIcon(), //用户头像
        // img: info,
        // writer: getwriter()
    },
    mutations: {
        SET_ID: (state, id) => {
            state.id = id;
        },
        // SET_INFO: (state, info) => {
        //   state.img = info;
        // },
        SET_NAME: (state, name) => {
            state.name = name;
        },
        SET_ICON: (state, icon) => {
            state.icon = icon;
        },

    },
    actions: {
        //   登录
        Login({ commit }, loginInfo) {
            return new Promise((resolve, reject) => {
                login(loginInfo)
                    .then(response => {
                        if (response.success) {
                            // console.log(response.data)
                            setUserId(response.data.id)
                            setUserName(response.data.name)
                            setUserIcon(response.data.iconUrlSmall)
                            commit("SET_ID", response.data.id);
                            commit("SET_NAME", response.data.name);
                            commit("SET_ICON", response.data.iconUrlSmall);
                        }
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        LogOut({ commit }) {
            return new Promise((resolve, reject) => {
                logout()
                    .then(response => {
                        if (response.success) {
                            // console.log(response.data)
                            commit("SET_ID", "");
                            commit("SET_NAME", "");
                            commit("SET_INFO", "");

                            removeUserId();
                            removeUserName();
                            removeUserIcon()
                            //   removeinfo();
                            removeToken();
                            clearStorage();
                            resolve(response);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        saveInfo({ commit }, res) {
            // console.log(res)
            setUserId(res.id);
            setUserName(res.name);
            if(res.iconUrlSmall) setUserIcon(res.iconUrlSmall);

            
            commit("SET_ID", res.id);
            commit("SET_NAME", res.name);
            if(res.iconUrlSmall)  commit("SET_ICON", res.iconUrlSmall);
        },
    }
};
export default user;
